import { render, staticRenderFns } from "./MGlobalFooter.vue?vue&type=template&id=64239b62&"
import script from "./MGlobalFooter.vue?vue&type=script&lang=ts&"
export * from "./MGlobalFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports